import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dark%20gothic%20mansion%20silhouette%20against%20blood%20red%20moon%2C%20ancient%20Victorian%20architecture%2C%20misty%20atmosphere%2C%20crimson%20and%20black%20color%20scheme%2C%20haunting%20yet%20elegant%20composition%2C%20cinematic%20wide%20shot%2C%20dark%20fantasy%20art%20style%2C%20volumetric%20fog%2C%20dramatic%20sky%2C%20no%20text%20no%20letters%20no%20words&width=1920&height=1080&seq=hero-bg-01&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 pt-20">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary-500/30 bg-primary-500/10 mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-primary-300 font-label tracking-wider">
              暗黑情色文学世界观完全指南
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-foreground-50 leading-tight mb-6 text-glow">
            邪娠娼馆
          </h1>

          <p className="text-base md:text-lg text-foreground-300 max-w-2xl mx-auto leading-relaxed mb-10">
            深入探索暗黑文学世界的终极指南。汇聚角色图鉴、剧情解析、设定考据与创作理念，
            为你揭示这部独特作品的全部魅力与深层叙事逻辑。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/character-guide"
              className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-label text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider"
            >
              <i className="ri-user-star-line mr-2"></i>
              探索角色图鉴
            </Link>
            <Link
              to="/category/story-analysis"
              className="px-8 py-3 rounded-lg border border-foreground-300/30 text-foreground-200 font-label text-sm hover:bg-foreground-50/5 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line mr-2"></i>
              深入剧情解析
            </Link>
          </div>

          <div className="mt-16 flex items-center justify-center gap-8 md:gap-12">
            {[
              { value: '25+', label: '深度文章' },
              { value: '6', label: '内容分类' },
              { value: '20+', label: '核心角色' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-foreground-400 text-2xl"></i>
      </div>
    </section>
  );
}